import { s as V } from "./banners.js";
import { S as u, P as L } from "./states.js";
import "./emotion-css-create-instance.esm.js";
const c = /* @__PURE__ */ new Map();
function C(o) {
  let i = c.get(o);
  return i || (i = new Promise((t, n) => {
    const d = document.createElement("script");
    d.src = o, d.onload = () => {
      d.remove(), t();
    }, d.onerror = () => {
      d.remove(), n();
    }, document.body.appendChild(d);
  }), c.set(o, i)), i;
}
const D = (o, i, t, n, d, g) => {
  if (g && g !== o[n].id && (o[n].id = g, o[n].quartile = -1), t) {
    const E = Math.floor(i * 4 / (t - 1));
    if (window.Number.isFinite(E) && (n === "ad" && E < o[n].quartile && (o[n].quartile = -1), E > o[n].quartile)) {
      o[n].quartile += 1;
      for (let I = o[n].quartile; I <= E; I += 1)
        d({ quartile: I });
      o[n].quartile = E;
    }
  }
}, h = (o, i) => {
  var t;
  (t = o.postroll) != null && t.isPlayingPostrollVideo() ? o.triggerQuartilePostroll(i) : o.triggerQuartile(i);
}, e = (o, i) => {
  const { events: t } = window.dailymotion, n = {
    ad: { id: "", quartile: -1 },
    video: { id: "", quartile: -1 }
  };
  i.on(t.VIDEO_TIMECHANGE, (d) => {
    i.listenEvents && D(
      n,
      d.videoTime ?? 0,
      d.videoDuration ?? 0,
      "video",
      (g) => h(o, g),
      d.videoId
    );
  }), i.on(
    t.AD_TIMECHANGE,
    (d) => D(
      n,
      d.adTime ?? 0,
      d.adDuration ?? 0,
      "ad",
      (g) => o.triggerQuartileAd(g),
      d.adId ?? d.adCreativeAdId ?? d.adCreativeId
    )
  );
}, R = (o, i, { title: t, mediaid: n }) => {
  i.listenEvents && n && (o.triggerPlaylistItem({
    index: i.playlistIndex,
    item: { mediaid: n, title: t ?? "" }
  }), o.triggerVideoStart({
    index: i.playlistIndex,
    item: { mediaid: n, title: t ?? "" }
  }));
}, Y = (o, i, t) => {
  t != null && t.videoId && (i.currentlyOnAManualPlaylist ? i.playlist[i.playlistIndex] = {
    mediaid: t.videoId,
    title: t.videoTitle ?? void 0
  } : (i.playlistIndex = i.playlist.findIndex((n) => n.mediaid === t.videoId), i.playlistIndex === -1 && (i.playlist.push({
    mediaid: t.videoId,
    title: t.videoTitle ?? void 0
  }), i.playlistIndex = i.playlist.length - 1)), R(o, i, {
    mediaid: t.videoId,
    title: t.videoTitle ?? ""
  }));
}, N = (o, i, t) => {
  i.listenEvents && t && !t.playerNextVideo && o.triggerPlaylistComplete();
}, T = (o) => {
  var i;
  return o.playlistIndex++, Array.isArray(o.playlist) ? ((i = o.playlist[o.playlistIndex]) == null ? void 0 : i.mediaid) ?? null : null;
}, O = (o, i, { video: t, ...n }, d, g) => {
  const {
    dailymotion: { events: E }
  } = window;
  let I = T(i);
  for (; !I && i.playlistIndex < i.playlist.length; )
    I = T(i);
  if (I)
    i.loadContent({
      video: I
    }), i.on(
      E.PLAYER_END,
      O.bind(void 0, o, i, { video: t, ...n }, d),
      { once: !0 }
    );
  else {
    i.currentlyOnAManualPlaylist = !1;
    const s = {
      ...n,
      video: t && (!(g != null && g.videoId) || t !== g.videoId) ? t : void 0
    };
    s.video && (s.playlist ? i.on(E.VIDEO_END, N.bind(void 0, o, i)) : i.listenEvents && i.playlistIndex > 1 && o.triggerPlaylistComplete(), i.listenEvents = !1, i.on(
      E.VIDEO_END,
      () => {
        i.listenEvents = !0;
      },
      { once: !0 }
    ), d && i.on(
      E.PLAYER_START,
      () => {
        i.setCustomConfig({ customParams: d });
      },
      { once: !0 }
    ), i.loadContent(s));
  }
}, x = (o, i, t, n, d, g) => {
  const {
    dailymotion: { events: E }
  } = window;
  t.length && i.playlist.length === 1 && t[0].mediaid === i.playlist[0].mediaid && t.shift(), i.playlist = [...i.playlist, ...t], d && i.setCustomConfig({ customParams: d }), i.currentlyOnAManualPlaylist = !0;
  const I = g || 0;
  i.on(
    E.PLAYER_END,
    (s) => {
      setTimeout(O, I, o, i, n, d, s);
    },
    { once: !0 }
  );
}, M = ({ keywordDisableAd: o, player: i, playlistId: t, timeoutPRT: n, webediaPlayer: d, webediaPlaylist: g }, E) => {
  const {
    dailymotion: { events: I }
  } = window;
  i.on(I.VIDEO_START, Y.bind(void 0, d, i)), E != null && E.videoId && (g.length && g[0].mediaid === (E == null ? void 0 : E.videoId) ? g[0].title = E.videoTitle ?? "" : g.unshift({
    mediaid: E.videoId,
    title: E.videoTitle ?? ""
  }), R(d, i, {
    mediaid: E.videoId,
    title: E.videoTitle ?? ""
  })), d.postroll && (g = d.postroll.setupPostrollAsVideoPlaylist(g)), g.length > 1 ? x(
    d,
    i,
    g,
    {
      // We want to recover the end screen of the Dailymotion video without
      // disabling the automatic start of the player, because the automatic
      // start is not managed individually for each video, but globally for a
      // player (of the Dailymotion back office).
      startTime: (E == null ? void 0 : E.videoDuration) ?? void 0,
      video: (E == null ? void 0 : E.videoId) ?? g[0].mediaid,
      playlist: t
    },
    o,
    n
  ) : (i.playlist = [...g, ...i.playlist], i.on(I.VIDEO_END, N.bind(void 0, d, i))), V(d, i.getRootNode());
}, l = (o, i, t, n, d, g) => {
  const {
    dailymotion: { events: E }
  } = window;
  i.playlist = [], i.playlistIndex = 0, i.getPlaylistIndex = () => i.playlistIndex, i.getPlaylistItem = (I = i.playlistIndex) => {
    var s;
    return ((s = i.playlist) == null ? void 0 : s[I]) ?? null;
  }, i.on(
    E.VIDEO_START,
    M.bind(void 0, {
      webediaPlayer: o,
      player: i,
      webediaPlaylist: t,
      keywordDisableAd: n,
      playlistId: d,
      timeoutPRT: g
    }),
    { once: !0 }
  );
}, r = (o) => o ? o === "preroll" ? "pre" : o === "midroll" ? "mid" : "post" : null;
let _ = 0;
const q = (o, i, t) => {
  var E, I;
  const { events: n } = window.dailymotion, d = ((I = (E = t.params) == null ? void 0 : E.customConfig) == null ? void 0 : I.customParams) ?? "";
  let g = !1;
  i.on(
    n.AD_CLICK,
    () => o.triggerAdClick({
      clickThroughUrl: "",
      client: "vast",
      creativetype: "",
      tag: d
    })
  ), i.on(n.AD_END, (s) => {
    var f;
    s.adEndedReason === "error" ? o.triggerAdError({
      message: ((f = s.adError) == null ? void 0 : f.message) ?? "",
      tag: d
    }) : g && s.adEndedReason === "skipped" && o.triggerAdSkipped({
      clickThroughUrl: "",
      client: "vast",
      creativetype: "",
      tag: d
    }), o.triggerAdEnd();
  }), i.on(n.AD_LOADED, (s) => {
    const f = r(s.adPosition);
    f && o.triggerAdRequest({
      adposition: f,
      client: "vast",
      offset: f === "mid" ? s.videoTime ?? 0 : f,
      tag: d,
      viewable: s.playerIsViewable ? 1 : 0
    });
  }), i.on(n.AD_PAUSE, () => o.triggerAdPause()), i.on(n.AD_PLAY, () => o.triggerAdPlay()), i.on(n.AD_START, (s) => {
    i.duration = s.adDuration ?? 0, i.position = 0;
  }), i.on(n.AD_TIMECHANGE, (s) => {
    i.position = s.adTime ?? 0, !g && s.adTime && (g = !0);
  }), i.on(n.PLAYER_HEAVYADSINTERVENTION, () => {
    o.triggerHeavyAdsIntervention();
  }), i.on(n.PLAYER_ERROR, (s) => {
    s.adError && o.triggerAdError({
      message: s.adError.message,
      tag: d
    }), i.listenEvents && (s.playerError && o.triggerError({
      code: s.playerError.code,
      message: s.playerError.message,
      sourceError: s.playerError,
      type: "error"
    }), s.playerIsPlaybackAllowed || o.triggerAutostartNotAllowed());
  }), i.on(n.PLAYER_CRITICALPATHREADY, () => o.triggerReady(), { once: !0 }), i.on(n.PLAYER_PLAYBACKPERMISSION, (s) => {
    i.listenEvents && !s.playerIsPlaybackAllowed && o.triggerAutostartNotAllowed();
  }), i.on(n.PLAYER_PRESENTATIONMODECHANGE, ({ playerPresentationMode: s }) => {
    i.listenEvents && o.triggerPlayerPresentationModeChange({
      playerPresentationMode: s
    });
  }), i.on(n.PLAYER_START, () => {
    o.triggerPlayerStart();
  }), i.on(n.VIDEO_BUFFERING, (s) => {
    i.listenEvents && o.triggerBuffer({
      newstate: s.playerIsBuffering ? "buffering" : s.playerIsPlaying ? "playing" : "paused"
    });
  }), i.on(n.VIDEO_PAUSE, (s) => {
    i.listenEvents && o.triggerPause({
      position: s.videoTime ?? 0
    });
  }), i.on(n.VIDEO_PROGRESS, (s) => {
    i.listenEvents && s.playerIsBuffering && o.triggerBuffer({
      newstate: "buffering"
    });
  }), i.on(n.VIDEO_SEEKEND, (s) => {
    i.listenEvents && o.triggerSeek({
      offset: s.videoTime ?? 0,
      position: _
    });
  }), i.on(n.VIDEO_SEEKSTART, (s) => {
    _ = s.videoTime ?? 0;
  }), i.on(n.VIDEO_START, (s) => {
    i.duration = s.videoDuration ?? 0, i.position = 0, i.listenEvents && s.playerIsBuffering && o.triggerBuffer({
      newstate: "buffering"
    });
  }), i.on(n.VIDEO_TIMECHANGE, (s) => {
    const f = s.videoTime ?? 0;
    i.position = f, i.listenEvents && o.triggerTime({
      duration: s.videoDuration ?? 0,
      position: f,
      viewable: s.playerIsViewable ? 1 : 0
    });
  }), i.on(n.VIDEO_END, () => {
    i.listenEvents && o.triggerBeforeComplete();
  });
}, m = (o, i, t) => {
  const n = {
    previousState: o.state,
    nextState: t
  };
  o.state = t, i.listenEvents && L.indexOf(t) > -1 && n.previousState === u.PAUSED && i.getState().then((d) => {
    o.triggerResume({
      position: d.videoTime ?? 0
    });
  });
}, G = (o, i) => {
  const { events: t } = window.dailymotion;
  i.on(t.AD_IMPRESSION, () => m(o, i, u.PLAYING_ADVERTISEMENT)), i.on(t.AD_END, () => m(o, i, u.IDLE)), i.on(t.VIDEO_END, () => m(o, i, u.IDLE)), o.addEventListener("postroll-start", () => m(o, i, u.PLAYING_POSTROLL)), i.on(
    t.VIDEO_PLAY,
    () => {
      var n;
      return m(
        o,
        i,
        (n = o.postroll) != null && n.isPlayingPostrollVideo() ? u.PLAYING_POSTROLL : u.PLAYING_VIDEO
      );
    }
  ), i.on(t.VIDEO_PAUSE, () => m(o, i, u.PAUSED));
}, B = "https://geo.dailymotion.com/libs/player/";
async function k(o, { timeoutPRT: i, keywordDisableAd: t, playlist: n, video: d, ...g }) {
  var A;
  await C(`${B}${g.player}.js`);
  const E = { ...g }, I = o.playlist ?? [], s = d ?? ((A = I[0]) == null ? void 0 : A.mediaid);
  typeof n == "string" && (!I.length || I.length === 1 && I[0].mediaid === s) && (E.playlist = n), E.video = s;
  const f = await window.dailymotion.createPlayer(o.container.id, E).then((v) => (v.listenEvents = !0, v.duration = 0, v.position = 0, v.getVersion = () => "", q(o, v, E), e(o, v), G(o, v), l(o, v, I, t, n, i), v.getDuration = () => v.duration, v.getPlayerId = () => v.getSettings().id, v.getPosition = () => v.position, v));
  o.setPlayer(f);
}
export {
  k as default
};
